import React, {useEffect, useState} from "react";
import "./style.css";
import {CREATING_PLAIN_COMMENT} from "../../../../../const/WeightLossQuestionnaire";
import {Percentage} from "../Percentage/Percentage";
import {calculatePersonalizedCalories} from "../../../../../utils/calorieCalculator";

import { Image } from "../../../../../components/Image";
export const MobileCreatingPlan = ({
    clickNext = () => {},
    clickPrev = () => {},
    percentageList,
    nextPercentage,
    data
                            }) => {
  const [calculatedData, setCalculatedData] = useState(() => {
    const result = calculatePersonalizedCalories(data);
    return {
      profile: result.profile,
      calories: result.targetCalories,
      dietaryPreference: result.dietaryPreference
    };
  });

  useEffect(() => {
    if (data) {
      const result = calculatePersonalizedCalories(data);
      setCalculatedData({
        profile: result.profile,
        calories: result.targetCalories,
        dietaryPreference: result.dietaryPreference
      });
    }
  }, [data]);
  const [curIndex, setCurIndex] = useState(0);
  const [add, setAdd] = useState(false);

  useEffect(() => {
    const time1 = setInterval(() => {
      setAdd(true);
    }, 3000)
    return () => {
      clearInterval(time1);
    }
  }, [])
  useEffect(() => {
    if (add) {
      clickPage(curIndex+1);
      setAdd(false);
    }

  }, [add]);

  const clickPage = (page) => {
    let number = CREATING_PLAIN_COMMENT.length;
    if (page >= number) {
      page -= number;
    } else if (page < 0) {
      page += number;
    }
    setCurIndex(page);
  }

  return (
    <div className="creating-plan-mobile" data-model-id="16713:12936">
      <div className="frame">
        <div className="div">
          <div className="title">
            <div className="text-wrapper">
              Creating your personalized plan...
            </div>
          </div>

          <div className="frame-2">
            <div className="element">
              <div className="date">
                <div 
                  className="profile-label"
                  style={{
                    color: (percentageList[0]?.start && !percentageList[1]?.start)
                      ? 'var(--material-themesyslighton-surface)' 
                      : 'var(--material-themesyslightoutline)'
                  }}
                >
                  Analyzing profile:
                </div>

                {percentageList[0]?.start && (
                  <div 
                    className="text-wrapper-2"
                    style={{
                      color: (percentageList[0]?.start && !percentageList[1]?.start)
                        ? 'var(--material-themesyslighton-surface)'
                        : 'var(--material-themesyslightoutline)',
                      fontWeight: (percentageList[0]?.start && !percentageList[1]?.start) ? 700 : 500
                    }}
                  >
                    {calculatedData.profile}
                  </div>
                )}
              </div>

              <Percentage start={percentageList[0]?.start} successBack={nextPercentage} />
            </div>

            <div className="element">
              <div className="date">
                <div 
                  className="text-wrapper-2"
                  style={{
                    color: (percentageList[1]?.start && !percentageList[2]?.start)
                      ? 'var(--material-themesyslighton-surface)' 
                      : 'var(--material-themesyslightoutline)',
                    fontWeight: (percentageList[1]?.start && !percentageList[2]?.start) ? 700 : 500
                  }}
                >
                  Calculating metabolism:
                </div>

                {percentageList[1]?.start && (
                  <div 
                    className="text-wrapper-2"
                    style={{
                      color: (percentageList[1]?.start && !percentageList[2]?.start)
                        ? 'var(--material-themesyslighton-surface)'
                        : 'var(--material-themesyslightoutline)',
                      fontWeight: (percentageList[1]?.start && !percentageList[2]?.start) ? 700 : 500
                    }}
                  >
                    {calculatedData.calories} kcal
                  </div>
                )}
              </div>

              <Percentage start={percentageList[1]?.start} successBack={nextPercentage} />
            </div>
          </div>

          <div className="element">
            <div className="date">
              <div 
                className="text-wrapper-2"
                style={{
                  color: percentageList[2]?.start 
                    ? 'var(--material-themesyslighton-surface)' 
                    : 'var(--material-themesyslightoutline)',
                  fontWeight: percentageList[2]?.start ? 700 : 500
                }}
              >
                Adjusting dietary preference:
              </div>

              {percentageList[2]?.start && (
                <div 
                  className="text-wrapper-2"
                  style={{
                    color: 'var(--material-themesyslighton-surface)',
                    fontWeight: 700
                  }}
                >
                  {calculatedData.dietaryPreference}
                </div>
              )}
            </div>

            <Percentage start={percentageList[2]?.start} successBack={nextPercentage} />
          </div>
        </div>

        <div className="review-container">
          {CREATING_PLAIN_COMMENT?.map((item, index) => {
            let style;
            if (curIndex === index) {
              style = {left: `0`, zIndex: 2}
            } else if ((curIndex === 0 && index === 2) || (curIndex === 1 && index === 0) || (curIndex === 2 && index === 1)) {
              style = {left: `calc(-100% - 16px)`, zIndex: 0}
            } else {
              style = {left: `calc(100% + 16px)`, zIndex: 1}
            }
            return <div className="review-container-3" style={style} key={index}>
              <div className="review-container-2">
                <Image src="/static/image/questionnaire/weight-loss/creatingPlan/star-rating.png" alt="Star rating" className="review-container-img" />

                <p className="review-text">
                  ”{item.content}“
                </p>

                <div className="reviewer-name">{item.name}</div>
              </div>
            </div>
          })}

        </div>
      </div>
    </div>
  );
};
